const CoordinatorsTypes = {
  SET_COORDINATORS_LOADING: 'COORDINATORS/SET_COORDINATORS_LOADING',
  SET_COORDINATORS_FAILURE: 'COORDINATORS/SET_COORDINATORS_FAILURE',
  SET_COORDINATORS_SUCCESS: 'COORDINATORS/SET_COORDINATORS_SUCCESS',
};

export default CoordinatorsTypes;